module.exports = __webpack_public_path__ + "img/3d_减速开关.12e0862a.png";